import $ from 'jquery';
import flatpickr from 'flatpickr';

import Dropzone from '../lib/dropzone';
import { formValidator } from '../utils/form-validator';

const registerEvent = () => {
  $('form').submit(() => false);

  let formValidate = false;
  const pleaseSelect = document.documentElement.lang == 'en' ? '' : 'الرجاء أختر';
  const requiredFieldError = document.documentElement.lang == 'en' ? 'This field is required.' : 'هذا الحقل مطلوب';
  let requestUrls;
  function setUrl(url) {
    requestUrls = url;
    alert(requestUrls);
  }
  let eventStartDate;
  let eventEndDate;
  let eventStartTime;
  let eventEndTime;
  let eventName;
  let eventNameAr;
  let eventDescription;
  let eventDescriptionAr;
  let projectManager;
  let managerEmail;
  let mobile;
  let eventEmirate;
  let eventLocation;
  let eventLocationAr;
  const eventCategories = [];
  let entityType;
  let entityName;
  let byRegistrationUrl;
  let entityOrEventURL;
  const eventCategoryGuid = [];
  const eventInterestGuid = [];
  const thumbFilesObj = [];
  const logoFilesObj = [];
  const bannerFilesObj = [];
  const isUpload = false;
  const progressVal = 0;
  const percent = 0;
  let multipleFile = false;
  const isCheck = false;
  let fileTypeInvalid = false;
  const grecaptchaWidget = '';
  let imageBannerDZ = null; // Will be used to send all data to server

  Dropzone.options.myAwesomeDropzone = false;
  const drop = $('#dz-preview-template').html();
  Dropzone.autoDiscover = false;

  $('#EventStartDate').keypress((event) => { event.preventDefault(); });
  $('#EventEndDate').keypress((event) => { event.preventDefault(); });
  $('#EventStartTime').keypress((event) => { event.preventDefault(); });
  $('#EventEndTime').keypress((event) => { event.preventDefault(); });

  const bannerImageHeight = 600;
  const bannerImageWidth = 1639;

  const bannerImageMinHeight = 485;
  const bannerImageMinWidth = 1350;

  let bannerImageDimensionError = false;
  let bannermaxFileExceedError = false;
  let bannerUploadFileError = false;

  const thumbnailImageHeight = 300;
  const thumbnailImageWidth = 400;

  const thumbnailImageMinHeight = 225;
  const thumbnailImageMinWidth = 300;

  let thumbnailImageDimensionError = false;
  let thumbnailUploadFileError = false;
  let thumbnailMaxFileExceedError = false;


  const init = () => {
    window.requiredFieldValidation = requiredFieldValidation;
    window.mobileValidation = mobileValidation;
    window.emailValidation = emailValidation;
    addNextEventListener();
    addPreviousEventListener();
    initializeDateTimepickers();
    initializeMultiselects();
    initializeBannerDropzone();
    initializeThumbnailDropzone();
    initializeEntityLogoDropzone();
  };

  const addNextEventListener = () => {
    let currentStep,
      nextStep;

    $('[data-register-event__validate]').click(function () {
      currentStep = $(this).closest('[data-js=register-event__fieldset]');
      nextStep = $(this).closest('[data-js=register-event__fieldset]').next();

      const currentStepIndex = $('[data-js=register-event__fieldset]').index(currentStep);

      if (currentStepIndex === 0) {
        if (validateStep1()) {
          $('[data-js=form-progress__step]')
            .eq(currentStepIndex + 1)
            .addClass('form-progress__step--completed');

          nextStep.show();
          currentStep.hide();
          $('html, body').animate({ scrollTop: 0 }, 'slow');
        }
      } else if (currentStepIndex === 1) {
        if (validateStep2()) {
          $('[data-js=form-progress__step]')
            .eq(currentStepIndex + 1)
            .addClass('form-progress__step--completed');

          nextStep.show();
          currentStep.hide();
          $('html, body').animate({ scrollTop: 0 }, 'slow');
        }
      } else if (currentStepIndex === 2) {
        if (validateStep3()) {
          /*  */
          imageBannerDZ.getValuesAndSendForUpload();
        }
      }
    });
  };

  const addPreviousEventListener = () => {
    let currentStep,
      previousStep;

    $('[data-js=register-event__previous]').click(function () {
      currentStep = $(this).closest('[data-js=register-event__fieldset]');
      previousStep = $(this).closest('[data-js=register-event__fieldset]').prev();

      $('[data-js=form-progress__step]').eq($('[data-js=register-event__fieldset]').index(currentStep)).removeClass('form-progress__step--completed');

      previousStep.show();
      currentStep.hide();
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    });
  };


  const validateStep1 = () => {
    let validatePart = true;
    validateRequiredField($('#EventName'), 'fullname');
    if (formValidate == false) { validatePart = formValidate; }
    validateRequiredField($('#EventNameAr'), 'fullnameAr');
    if (formValidate == false) { validatePart = formValidate; }
    validateRequiredField($('#EventStartDate'), 'date');
    if (formValidate == false) { validatePart = formValidate; }
    validateRequiredField($('#EventEndDate'), 'dateAr');
    if (formValidate == false) { validatePart = formValidate; }
    validateRequiredField($('#EventStartTime'), 'time');
    if (formValidate == false) { validatePart = formValidate; }
    validateRequiredField($('#EventEndTime'), 'timeAr');
    if (formValidate == false) { validatePart = formValidate; }
    validateRequiredField($('#EventDesc'), 'desc');
    if (formValidate == false) { validatePart = formValidate; }
    validateRequiredField($('#EventDescAr'), 'descAr');
    if (formValidate == false) { validatePart = formValidate; }
    validateRequiredField($('#EventEmirate'), 'emirate', true);
    if (formValidate == false) { validatePart = formValidate; }
    validateRequiredField($('#EventLocation'), 'loc');
    if (formValidate == false) { validatePart = formValidate; }
    validateRequiredField($('#EventLocationAr'), 'locAr');
    if (formValidate == false) { validatePart = formValidate; }

    checkDateValidations();
    if (formValidate == false) { validatePart = formValidate; }

    return validatePart;
  };

  const validateStep2 = () => {
    let validatePart = true;

    validateRequiredField($('#eventType'), 'evType', true);
    if (formValidate == false) { validatePart = formValidate; }

    validateMultiselectField($('#eventCategory'), 'catType', eventCategories);
    if (formValidate == false) { validatePart = formValidate; }

    if (bannerFilesObj.length == 0) {
      $('#addBannerImg').addClass('dropzone__input--error');
      $('#bannerValidation').html(`<span class="form__input-error help-block"><span class="field-validation-error">${requiredFieldError}</span></span>`);
      $('');
      formValidate = false;
    }
    if (formValidate == false) { validatePart = formValidate; }

    if (thumbFilesObj == 0) {
      $('#addThumbImg').addClass('dropzone__input--error');
      $('#thumbnailValidation').html(`<span class="form__input-error help-block"><span class="field-validation-error">${requiredFieldError}</span></span>`);
      formValidate = false;
    }
    if (formValidate == false) { validatePart = formValidate; }

    return validatePart;
  };

  const validateStep3 = () => {
    let validatePart = true;

    validateRequiredField($('#projectmanager'), 'pm');
    if (formValidate == false) { validatePart = formValidate; }

    mobileValidation($('#mobile'), 'mble');
    if (formValidate == false) { validatePart = formValidate; }

    emailValidation($('#manageremail'), 'email');
    if (formValidate == false) { validatePart = formValidate; }

    validateCaptcha($('#grecaptcha'), 'captcha');
    if (formValidate == false) { validatePart = formValidate; }

    return validatePart;
  };

  function validateRequiredField(field, id, isCategory) {
    clearOneErrorMessage(field, id);
    const fieldValue = $(field).val();
    if (isEmpty(fieldValue) || fieldValue == pleaseSelect || fieldValue == null) {
      if (!isCategory || isCategory == null) { setErrorMessage(field, requiredFieldError, id); } else { setErrorMessageForCategory(field, requiredFieldError, id); }
      formValidate = false;
      return false;
    }

    formValidate = true;


    return true;
  }

  function validateMultiselectField(field, id, selectedOptions) {
    clearOneErrorMessage(field, id);

    if (selectedOptions.length === 0) {
      setErrorMessageForCategory(field, requiredFieldError, id);

      formValidate = false;
      return false;
    }

    formValidate = true;


    return true;
  }

  function validateCaptcha(field, id) {
    //  formValidate = true;
    clearOneErrorMessage(field, id);

    const response = grecaptcha.getResponse();
    if (response.length == 0) {
      setErrorMessageCustom(field, requiredFieldError, id);
      formValidate = false;
    } else {
      formValidate = true;
    }
  }

  function checkDateValidations() {
    const eventStartDate = $('#EventStartDate').val();
    const eventEndDate = $('#EventEndDate').val();

    if (eventStartDate.length != 0 && eventEndDate.length != 0) {
      // if (new Date(eventStartDate).valueOf() >= new Date(eventEndDate).valueOf()) {
      //   // alert('Error... Start date can not be greater than end date');
      //    return;
      // }
      if (new Date(eventEndDate).valueOf() < new Date(eventStartDate).valueOf()) {
        // alert('Error... End date can not be less than Start date');
        validateEndDate($('#EventEndDate'), 'datevalid', true);
      } else {
        validateEndDate($('#EventEndDate'), 'datevalid', false);
      }
    }
    // else {
    //  //  alert('Date is Empty');
    // }
  }

  function validateEndDate(field, id, isBool) {
    if (!isBool) {
      clearOneErrorMessage(field, id);
      formValidate = true;
    } else {
      const message = formValidator.getLanguage() === 'en' ? 'End date should be greater than start date'
        : 'تاريخ النهايه يجب ان يكون اكبر من تاريخ البداية';
      setErrorMessage(field, message, id);
      formValidate = false;
    }
  }
  function requiredFieldValidation(elem, id) {
    if ($(`#${elem.id}`).val() == '') {
      setErrorMessage($(`#${elem.id}`), requiredFieldError, id);
      return false;
    }

    clearOneErrorMessage($(`#${elem.id}`), id);


    return true;
  }
  function clearOneErrorMessage(element, id) {
    $(`#${id}`).remove();
  }

  function isEmpty(text) {
    return !/[^\s]/.test(text);
  }

  function setErrorMessage(element, message, id) {
    if (!$(`#${id}`).html()) {
      element.parent('.form__group').append(`<div id="${id}" class="form__input-error"><span class="help-block"><span class="field-validation-error">${message}</span></span></div>`);
    }
  }
  function setErrorMessageCustom(element, message, id) {
    if (!$(`#${id}`).html()) {
      element.parent().append(`<div id="${id}" class="form__input-error"><span class="help-block"><span class="field-validation-error">${message}</span></span></div>`);
    }
  }
  function setErrorMessageForCategory(element, message, id) {
    if (!$(`#${id}`).html()) {
      element.closest('.form__group').append(`<div id="${id}" class="form__input-error"><span class="help-block"><span class="field-validation-error">${message}</span></span></div>`);
    }
  }
  function emailValidation(elem, id) {
    if (validateRequiredField(elem, id, false)) {
      if (!formValidator.validateEmailSyntax(elem.val())) {
        const message = formValidator.getLanguage() === 'en' ? 'Invalid Email' : 'بريد ألكترونى غير صحيح';
        setErrorMessage(elem, message, id);
        formValidate = false;
      }
    }
  }

  function mobileValidation(elem, id) {
    if (validateRequiredField(elem, id, false)) {
      if (!formValidator.validateConatctNo(elem.val())) {
        const message = formValidator.getLanguage() === 'en' ? 'Contact number is not valid' : 'رقم التواصل الذي أدخلته غير صحيح';
        setErrorMessage(elem, message, id);
        formValidate = false;
      }
    }
  }

  function initializeMultiselects() {
    // hide dropdowns in case of clicking outside
    $('body').click((e) => {
      const trigger = $('[data-js=form__multiselect]');
      if (trigger !== e.target && !trigger.has(e.target).length) {
        $('.dropdown-menu').hide();
      }
    });

    // CHECK inputs in multiselect
    $('[data-js=event-category-dropdown] a').on('click', (event) => {
      let $target = $(event.currentTarget),
        val = $target.attr('data-value'),
        $inp = $target.find('input'),
        idx;

      if ((idx = eventCategories.indexOf(val)) > -1) {
        eventCategories.splice(idx, 1);
        setTimeout(() => { $inp.prop('checked', false); }, 0);
      } else {
        eventCategories.push(val);
        setTimeout(() => { $inp.prop('checked', true); }, 0);
      }
      $(event.target).blur();
      return false;
    });

    // Toggling multiselect dropdown
    $('[data-js=dropdown-toggle]').on('click', () => {
      const optionsVisible = $('[data-js=event-category-dropdown]').css('display') != 'none';
      if (!optionsVisible) {
        $('.dropdown-menu').show();
      } else {
        $('.dropdown-menu').hide();
      }
    });
  }

  function initializeBannerDropzone() {
    if ($('#addBannerImg').length == 0) {
      return;
    }

    imageBannerDZ = new Dropzone('#addBannerImg', {
      url: '/UaeEvent/UploadFiles',
      autoProcessQueue: false,
      uploadMultiple: true,
      maxFilesize: 2.1,
      parallelUploads: 100,
      acceptedFiles: 'image/jpeg,image/png',
      maxThumbnailFilesize: 2.1,
      maxFiles: 1,
      previewTemplate: drop,
      // , thumbnailWidth: 1366
      // , thumbnailHeight: 500
      previewsContainer: '#template-preview',
      init() {
        const wrapperThis = this;

        this.on('thumbnail', (file) => {
          if (bannermaxFileExceedError) {
            bannermaxFileExceedError = false;
            return;
          }


          // if(bannerUploadFileError){

          //    bannerUploadFileError = false;
          //    return;
          // }

          if ((file.width >= bannerImageMinWidth && file.width <= bannerImageWidth) &&
                   (file.height >= bannerImageMinHeight && file.height <= bannerImageHeight)) {

          } else if (fileTypeInvalid == false) {
            bannerImageDimensionError = true;
            wrapperThis.removeFile(file);
          } else {
            fileTypeInvalid = false;
          }
        });

        // Submit listener

        this.on('removedfile', (file) => {
          multipleFile = false;
          bannerFilesObj.pop(file);
          $('#total-progress').fadeOut();
          document.querySelector('#total-progress .progress-bar').style.width = '0%';
          $('#addBannerImg').removeClass('dropzone__input--error');


          if (bannerImageDimensionError) {
            $('#addBannerImg').addClass('dropzone__input--error');
            $('#bannerImageDimension').fadeIn();
            bannerImageDimensionError = false;
          }
        });
        this.on('error', (file) => {
          bannerUploadFileError = true;
          multipleFile = false;
          if (file.size > 2000000) {
            $('#addBannerImg').addClass('dropzone__input--error');
            $('#errorMsg5').fadeIn();
          }
          // alert('Only png,jpeg and jpg are allowed');
          wrapperThis.removeFile(file);
        });
        this.on('addedfile', (file) => {
          $('#addBannerImg').removeClass('dropzone__input--error');
          $('#errorMsg4').fadeOut('slow');
          $('#errorMsg5').fadeOut('slow');
          $('#bannerfiletypevalidation').fadeOut('slow');
          $('#bannerImageDimension').fadeOut('slow');

          const filename = file.name.split('.');
          if (filename[filename.length - 1] == 'jpg' || filename[filename.length - 1] == 'JPG'
                  || filename[filename.length - 1] == 'png' || filename[filename.length - 1] == 'PNG'
                  || filename[filename.length - 1] == 'jpeg' || filename[filename.length - 1] == 'JPEG') {
            $('#bannerValidation').html('');
            bannerFilesObj.push(file);
            // setTimeout(function () {
            //    if (!multipleFile) {
            //        percent = 100 / (bannerFilesObj.length);
            //        setProgress(percent, bannerFilesObj);
            //        multipleFile = true;
            //    }
            // }, 2000);
          } else {
            $('#bannerfiletypevalidation').fadeIn();
            $('#addBannerImg').addClass('dropzone__input--error');
            wrapperThis.removeFile(file);
            fileTypeInvalid = true;
          }
        });
        this.on('sendingmultiple', (data, xhr, formData) => {
          const grecaptchaWidget = '';
          if (data.length > 0) {
            formData.append('BannnerImage', data[0].name);
          }
          multipleFile = false;
          if (thumbFilesObj.length > 0) {
            data.push(thumbFilesObj[0]);
            formData.append('Thumbnail', thumbFilesObj[0].name);
          }
          if (logoFilesObj.length > 0) {
            data.push(logoFilesObj[0]);
            formData.append('Logo', logoFilesObj[0].name);
          }

          formData.append('EventCategoryIds', eventCategories);
          formData.append('EventInterestIds', $('#eventType :selected').val());
          formData.append('EventStartDate', eventStartDate);
          formData.append('EventEndDate', eventEndDate);
          formData.append('EventStartTime', eventStartTime);
          formData.append('EventEndTime', eventEndTime);
          formData.append('EventName', eventName);
          formData.append('EventNameAr', eventNameAr);
          formData.append('EventDescription', eventDescription);
          formData.append('EventDescriptionAr', eventDescriptionAr);
          formData.append('ProjectManager', projectManager);
          formData.append('ManagerEmail', managerEmail);
          formData.append('Mobile', mobile);
          formData.append('EventEmirate', eventEmirate);
          formData.append('EventLocation', eventLocation);
          formData.append('EventLocationAr', eventLocationAr);
          formData.append('EntityType', entityType);
          formData.append('EntityName', entityName);
          formData.append('EntityOrEventURL', entityOrEventURL);
          formData.append('RegistrationUrl', byRegistrationUrl);
          formData.append('Other', $('#Other').val());
          formData.append('Opentopublic', $('#opentopublic').is(':checked'));
          formData.append('Familyfriendly', $('#familyfriendly').is(':checked'));
          formData.append('Privateinternal', $('#privateInternal').is(':checked'));
          formData.append('Registration', $('#chkByRegistration').is(':checked'));
          formData.append('SelectedEmirate', $('#EventEmirate option:selected').val());
          formData.append('SelectedEntity', $('#txtEntity').val());
          formData.append('SelectedEntityName', $('#txtEntityName').val());
          // formData.append("captcha", grecaptcha.getResponse());
        });
        this.on('sending', (file) => {
          multipleFile = false;
        });
        this.on('maxfilesexceeded', (file) => {
          bannermaxFileExceedError = true;
          $('#addBannerImg').addClass('dropzone__input--error');
          $('#errorMsg4').fadeIn();
        });
        this.on('successmultiple', (file, response) => {
          $('.loader').addClass('is-active');
          if (response.response == 4) {
            window.location.href = $('#requestUrl').val();
          } else {
            alert(response.ResponseMessage);
            $('.loader').removeClass('is-active');
          }
        });
      }
    });

    imageBannerDZ.getValuesAndSendForUpload = function () {
      const wrapperThis = this;

      multipleFile = false;
      eventStartDate = $('#EventStartDate').val();
      eventEndDate = $('#EventEndDate').val();
      eventStartTime = $('#EventStartTime').val();
      eventEndTime = $('#EventEndTime').val();
      eventName = $('#EventName').val();
      eventNameAr = $('#EventNameAr').val();
      eventDescription = $('#EventDesc').val();
      eventDescriptionAr = $('#EventDescAr').val();
      projectManager = $('#projectmanager').val();
      managerEmail = $('#manageremail').val();
      mobile = $('#mobile').val();
      eventEmirate = $('#EventEmirate :selected').text();
      eventLocation = $('#EventLocation').val();
      eventLocationAr = $('#EventLocationAr').val();
      entityType = $('#EntityType').val();
      entityName = $('#EntityName').val();
      entityOrEventURL = $('#entityeventurl').val();

      wrapperThis.processQueue(); // triggers uploading in sendingmultiple method
      $('.loader').addClass('is-active');
    };
  }

  function initializeThumbnailDropzone() {
    if ($('#addThumbImg').length == 0 || $('#dz-preview-template2').length == 0) {
      return;
    }

    const drop2 = $('#dz-preview-template2').html();

    const imageThumbnailDZ = new Dropzone('#addThumbImg', {
      url: '/',
      autoProcessQueue: false,
      maxFilesize: 2.1,
      acceptedFiles: 'image/jpeg,image/png',
      maxThumbnailFilesize: 2.1,
      previewTemplate: drop2,
      previewsContainer: '#thumb-preview',
      uploadMultiple: true,
      // , thumbnailWidth: 260
      // , thumbnailHeight: 180
      maxFiles: 1,
      init() {
        // var wrapperThis = this;

        const wrapperThis = this;

        this.on('thumbnail', (file) => {
          if (thumbnailMaxFileExceedError) {
            thumbnailMaxFileExceedError = false;
            return;
          }

          // if (thumbnailUploadFileError) {

          //    thumbnailUploadFileError = false;
          //    return;
          // }

          if ((file.width >= thumbnailImageMinWidth && file.width <= thumbnailImageWidth) &&
                    (file.height >= thumbnailImageMinHeight && file.height <= thumbnailImageHeight)) {

          } else if (fileTypeInvalid == false) {
            thumbnailImageDimensionError = true;
            wrapperThis.removeFile(file);
          } else {
            fileTypeInvalid = false;
          }
        });

        this.on('maxfilesexceeded', (file) => {
          thumbnailMaxFileExceedError = true;
          // wrapperThis.removeFile(file);
          $('#errorMsg1').fadeIn();
          $('#addThumbImg').addClass('dropzone__input--error');
        });
        this.on('removedfile', (file) => {
          thumbFilesObj.pop(file);
          // wrapperThis.removeFile(file);
          $('#total-progress1').fadeOut();
          document.querySelector('#total-progress1 .progress-bar').style.width = '0%';

          if (thumbnailImageDimensionError) {
            $('#thumbnailDimension').fadeIn();
            $('#addThumbImg').addClass('dropzone__input--error');
            thumbnailImageDimensionError = false;
          }
        });
        this.on('addedfile', (file) => {
          $('#errorMsg1').fadeOut('slow');
          $('#errorMsg6').fadeOut('slow');
          $('#thumbnailDimension').fadeOut('slow');
          $('#thumbnailfiletypevalidation').fadeOut('slow');
          $('#addThumbImg').removeClass('dropzone__input--error');


          const filename = file.name.split('.');
          if (filename[filename.length - 1] == 'jpg' || filename[filename.length - 1] == 'JPG'
                    || filename[filename.length - 1] == 'png' || filename[filename.length - 1] == 'PNG'
                    || filename[filename.length - 1] == 'jpeg' || filename[filename.length - 1] == 'JPEG') {
            thumbFilesObj.push(file);
            //   $('#total-progress1 .filename').html(file.name);
            //   $('#total-progress1 .filesize').html(file.size);
            //   $("#total-progress1").fadeIn();
            //    document.querySelector("#total-progress1 .progress-bar").style.width = "100%";
            //    $("#total-progress1").fadeOut('slow');
            $('#thumbnailValidation').html('');
          } else {
            $('#thumbnailfiletypevalidation').fadeIn();
            $('#addThumbImg').addClass('dropzone__input--error');
            wrapperThis.removeFile(file);
            fileTypeInvalid = true;
          }
        });
        this.on('sending', (data, xhr, formData) => {


        });
        this.on('sendingmultiple', (data, xhr, formData) => {


        });
        this.on('error', (file) => {
          thumbnailUploadFileError = true;
          if (file.size > 2000000) {
            $('#errorMsg6').fadeIn();
            $('#addThumbImg').addClass('dropzone__input--error');
          }
          // multipleFile = false;
          // alert('Only png,jpeg and jpg are allowed');
          wrapperThis.removeFile(file);
        });
      }
    });
  }

  function initializeEntityLogoDropzone() {
    if ($('#addEntityLogo').length == 0 || $('#dz-preview-template3').length == 0) {
      return;
    }

    const drop3 = $('#dz-preview-template3').html();

    const entityLogoDZ = new Dropzone('#addEntityLogo', {
      url: '/',
      autoProcessQueue: false,
      maxFilesize: 2.1,
      acceptedFiles: 'image/jpeg,image/png',
      maxThumbnailFilesize: 2.1,
      previewTemplate: drop3,
      previewsContainer: '#entity-preview',
      uploadMultiple: true,
      // , thumbnailWidth: 160
      // , thumbnailHeight: 120
      maxFiles: 1,
      init() {
        const wrapperThis = this;
        this.on('maxfilesexceeded', (file) => {
          // wrapperThis.removeFile(file);
          $('#errorMsg2').fadeIn();
          $('#errorMsg2').delay(2000).fadeOut('slow');
        });
        this.on('removedfile', (file) => {
          logoFilesObj.pop(file);
          //    wrapperThis.removeFile(file);
          //  $("#total-progress2").fadeOut();
          //  document.querySelector("#total-progress2 .progress-bar").style.width = "0%";
        });
        this.on('addedfile', (file) => {
          const filename = file.name.split('.');
          if (filename[filename.length - 1] == 'jpg' || filename[filename.length - 1] == 'JPG'
                    || filename[filename.length - 1] == 'png' || filename[filename.length - 1] == 'PNG'
                    || filename[filename.length - 1] == 'jpeg' || filename[filename.length - 1] == 'JPEG') {
            logoFilesObj.push(file);
          } else {
            $('#logofiletypevalidation').fadeIn();
            $('#logofiletypevalidation').delay(2000).fadeOut('slow');
            wrapperThis.removeFile(file);
          }

          // $('#total-progress2 .filename').html(file.name);
          //  $('#total-progress2 .filesize').html(file.size);
          //  $("#total-progress2").fadeIn();
          //  document.querySelector("#total-progress2 .progress-bar").style.width = "100%";
          //  $("#total-progress2").fadeOut('slow');
        });
        this.on('sendingmultiple', (data, xhr, formData) => {

        });
        this.on('sending', (file) => {

        });
        this.on('error', (file) => {
          if (file.size > 2000000) {
            $('#errorMsg7').fadeIn();
            $('#errorMsg7').delay(2000).fadeOut('slow');
          }
          // multipleFile = false;
          // alert('Only png,jpeg and jpg are allowed');
          wrapperThis.removeFile(file);
        });
      }
    });
  }


  return ({
    init
  });
};

export default registerEvent;


function initializeDateTimepickers() {
  flatpickr('[data-js=datepicker]', {
    dateFormat: 'Y/m/d',
    minDate: 'today',
    maxDate: new Date().fp_incr(365) // 365 days from now
  });

  flatpickr('[data-js=timepicker]', {
    enableTime: true,
    noCalendar: true,
    dateFormat: 'H:i'
  });
}

